<div class="w-full px-6 md:px-12 lg:px-24 bg-drak-green py-3">
    <div class="w-full flex flex-col md:flex-row justify-between items-center">
        <div class="flex flex-col md:flex-row justify-start gap-3 gap-x-8">
            <div class="text-white">
                © {{year}} Haibu. {{ 'rightsReserved' | translate }}
            </div>

            <div class="flex justify-center">
                <a id="loginPrivacyAdvice" href="/notice" target="_blank" class="color-haibu uppercase tracking-widest">
                    {{"loginPrivacyAdvice" | translate}}
                </a>
            </div>
        </div>
        <div class="flex justify-start gap-2.5 items-center">
            <a id="linkedinIcon" class="pt-2 pb-2" href="https://www.linkedin.com/company/haibuhr/" target="_blank">
                <img loading="lazy" class="h-7 w-7" [src]="linkedinIcon" alt="linkedin">
            </a>
            <a id="fbIcon" class="pt-2 pb-2" href="https://www.facebook.com/haibu.hr" target="_blank">
                <img loading="lazy" class="h-7 w-7" [src]="fbIcon" alt="facebook">
            </a>
            <a id="igIcon" class="pt-2 pb-2" href="https://www.instagram.com/haibu.hr/" target="_blank">
                <img loading="lazy" class="h-7 w-7" [src]="igIcon" alt="instagram">
            </a>
            <a id="ytIcon" class="pt-2 pb-2" href="https://www.youtube.com/@HaibuHR" target="_blank">
                <img loading="lazy" class="h-7 w-7" [src]="ytIcon" alt="youtube">
            </a>
        </div>
    </div>
</div>